import { render, staticRenderFns } from "./CreateMailboxModal.vue?vue&type=template&id=2342e1d0&"
import script from "./CreateMailboxModal.vue?vue&type=script&lang=js&"
export * from "./CreateMailboxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2342e1d0')) {
      api.createRecord('2342e1d0', component.options)
    } else {
      api.reload('2342e1d0', component.options)
    }
    module.hot.accept("./CreateMailboxModal.vue?vue&type=template&id=2342e1d0&", function () {
      api.rerender('2342e1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/CreateMailboxModal.vue"
export default component.exports